module.exports = __webpack_public_path__ + "static/media/footer-logo.0d0b44ff.svg";